import { Link } from "@chakra-ui/react"

export const ButtonPrimary = ({ isExternal,href,children ,...rest }) =>{
    return(
        <Link
            w="110px"
            h="50px"
            bg="pink.500"
            padding="5px"
            _hover={{
                bg:"pink.600"
            }}
            borderRadius="none"
            href={href}
            isExternal={isExternal}
            textAlign="center"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight="bold"
        >{ children }</Link>
    )
}